import React from "react";

import Banner from "./Banner";
import Services from "./Services";
import About from "./About";

const HomePage = () => {
    return (
        <div className="font-sans">
          <Banner />
          <Services />
          <About />
        </div>
    );
};

export default HomePage;
